<template>
  <div>
    <div
      v-for="(item, index) in invoiceList"
      :key="index"
      :style="{ color: getFieldColor(item.bill_type) }"
    >
      {{ getFieldValue(item) }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'InvoiceListField',
  props: {
    invoiceList: {
      type: Array,
      default: () => []
    },
    fieldKey: {
      type: String,
      required: true
    }
  },
  methods: {
    getFieldValue(invoice) {
      const value = invoice[this.fieldKey]

      if(!value && value !== 0) return '-'

      const prefix = this.fieldKey === 'amount' ? '￥' : ''

      return `${prefix}${value}`
    },
    getFieldColor(billType) {
      const redColorBillTypes = ['2', '3', '4', '5', '6']
      return redColorBillTypes.includes(String(billType)) ? '#f0150f' : 'inherit'
    }
  }
}
</script>
